import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const CUSTOM_STYLES = {
    content: { padding: 0, width: 550 },
};

export const StyledFooter = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding: 16px;

    & > *:not(:last-child) {
        margin-right: 4px;
    }
`;

export const StyledConfirmationText = styled.p`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    margin: 16px 0 0;
`;

export const StyledMain = styled.div`
    flex-grow: 1;
    padding: 0 24px;
`;

export const StyledErrorBannerWrapper = styled.div`
    margin-top: 16px;
`;

export const StyledTitle = styled.h3`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    margin: 0;
`;

export const StyledHeader = styled.div`
    flex-shrink: 0;
    padding: 20px 24px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 184px;
    user-select: none;
`;
